import React from "react";
import { QontoStepIconRoot } from "./lead-view-timeline.constant";
import { StepIconProps } from "@mui/material/StepIcon";

export function LeadViewTimelineStepIcon(props: StepIconProps) {
  const { active, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      <div className="QontoStepIcon-circle" />
    </QontoStepIconRoot>
  );
}
